import Chadsvasc from "../../../../src/client/katnh/widgets/Chadsvasc.js";
import * as React from 'react';
export default {
  Chadsvasc,
  React
};